<template>
    <v-select :options="vouchers" :reduce="name => name.id" label="name"/>
</template>

<script>
import { computed, onMounted } from '@vue/runtime-core';
import vSelect from 'vue-select';
import { useStore } from 'vuex';

export default {
    components: {
        vSelect
    },
    props: {
        merchantid: String,
        branchid: String,
    },
    setup(props, { emit }) {
        const store = useStore();
        const vouchers = computed(() => {
            return store.state.Voucher.vouchers;
        });

        onMounted(() => {
            loadVoucher();
        });

        const loadVoucher = async () => {
            // let filter = {
            //     branch_id: props.branchid,
            // }

            // if (props.merchantid) {
            //     filter = {
            //         merchant_id: props.merchantid,
            //         position: 'create'
            //     }
            // }

            // console.log(filter);
            

            // store.commit('Voucher/add_filter', {filter});
            if (props.merchantid) {
                store.dispatch('Voucher/all', props.merchantid).then(() => {
                    // store.commit('Voucher/clear_filter');
                    emit('loaded');
                });
            }
        };

        return {
            vouchers,
        }
    }
}
</script>